module.exports = __webpack_public_path__ + "img/melli.5503861b.png";